<template>
  <el-select v-model="status" placeholder="状态">
    <el-option
      v-for="item in statusList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      status: this.value,
      statusList: [
        { label: "初始化", value: 0 },
        { label: "上架", value: 10 },
        { label: "下架", value: 20 },
        { label: "删除", value: 30 },
      ],
    };
  },
  watch: {
    value(newValue) {
      this.status = newValue;
    },
    status(newStatus) {
      this.$emit("input", newStatus);
    },
  },
};
</script>

<style></style>
